import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const SmartScheduleCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SmartScheduleCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smartScheduleCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduled_cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card_id"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"SmartScheduleCards","document":SmartScheduleCardsDocument}} as const;
export type SmartScheduleCardsMutationVariables = Types.Exact<{
  cardIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  traceId: Types.Scalars['String']['input'];
}>;


export type SmartScheduleCardsMutation = (
  { __typename: 'Mutation' }
  & { smartScheduleCards?: Types.Maybe<(
    { __typename: 'SmartScheduleCardsResponse' }
    & { scheduled_cards: Array<(
      { __typename: 'SmartScheduleCard' }
      & Pick<Types.SmartScheduleCard, 'card_id' | 'end_time' | 'reason' | 'start_time'>
    )> }
  )> }
);

export type SmartScheduleCardsMutationFn = Apollo.MutationFunction<
  SmartScheduleCardsMutation,
  SmartScheduleCardsMutationVariables
>;

/**
 * __useSmartScheduleCardsMutation__
 *
 * To run a mutation, you first call `useSmartScheduleCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmartScheduleCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smartScheduleCardsMutation, { data, loading, error }] = useSmartScheduleCardsMutation({
 *   variables: {
 *      cardIds: // value for 'cardIds'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useSmartScheduleCardsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SmartScheduleCardsMutation,
    SmartScheduleCardsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SmartScheduleCardsMutation,
    SmartScheduleCardsMutationVariables
  >(SmartScheduleCardsDocument, options);
}
export type SmartScheduleCardsMutationHookResult = ReturnType<
  typeof useSmartScheduleCardsMutation
>;
export type SmartScheduleCardsMutationResult =
  Apollo.MutationResult<SmartScheduleCardsMutation>;
export type SmartScheduleCardsMutationOptions = Apollo.BaseMutationOptions<
  SmartScheduleCardsMutation,
  SmartScheduleCardsMutationVariables
>;
